"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoPluginHint = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Link_1 = require("@skbkontur/react-ui/components/Link");

var PluginHint_module_css_1 = tslib_1.__importDefault(require("./PluginHint.module.css"));

var configuration_1 = require("../../../contexts/configuration");

exports.NoPluginHint = function () {
  return react_1.default.createElement(configuration_1.WithConfiguration, null, function (_a) {
    var pluginInstallLink = _a.pluginInstallLink,
        installPluginOnNewTab = _a.installPluginOnNewTab;
    var target = installPluginOnNewTab ? '_blank' : '_self';
    pluginInstallLink += "?back=" + encodeURIComponent(location.href);
    return react_1.default.createElement("div", {
      className: PluginHint_module_css_1.default.pad
    }, "\u0427\u0442\u043E\u0431\u044B \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u043D\u0430\xA0\u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u0435, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435", ' ', react_1.default.createElement(Link_1.Link, {
      href: pluginInstallLink,
      target: target
    }, "\u041A\u043E\u043D\u0442\u0443\u0440.\u041F\u043B\u0430\u0433\u0438\u043D"));
  });
};